import breakpoint from '@/client/components/theme/breakpoint'
import styled from 'styled-components'

export const BlogItemWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -1rem;
  min-height: 1rem;
  @media (min-width: ${breakpoint.md}) {
    min-height: 10rem;
  }
`
export const SingleBlogCard = styled.div<{ gridtype: string }>`
  width: calc((100% / 1) - 2rem);
  margin: 2rem 1rem;

  & img {
    width: ${(p) => (p.gridtype === '1' ? `100%` : `auto`)};
    height: auto;
  }

  @media (min-width: ${breakpoint.md}) {
    width: ${(p) => (p.gridtype === '1' ? `100%` : `calc((100% / 3) - 2rem)`)};
    margin: 2rem 1rem;
  }
`
export const PaginationWrapper = styled.div`
  margin: 2rem 0;
`
